// extracted by mini-css-extract-plugin
export default {"button-segment":"button-segment_CU_2Q"};